import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { GetGiftTicketsByBenefitResponse } from 'app/core/responses/GetGiftTicketsByBenefitResponse';
import { AuthenticationService } from 'app/core/service';
import { GiftTicketsService } from 'app/core/service/gift-tickets.service';
import * as _ from 'lodash';



@Component({
  selector: 'app-benefit-availability',
  templateUrl: './benefit-availability.component.html',
  styleUrls: ['./benefit-availability.component.scss']
})
export class BenefitAvailabilityComponent implements OnInit, OnChanges {
  companyId: number;
  orderableBy: any[];
  orderablePeriods: any[];
  gifTicketEvents: any[];

  constructor(
    private giftTicketsService: GiftTicketsService,
    private _authenticationService: AuthenticationService,
  ) { }

  @Input() benefitId;
  @Input() benefitCategory;

  ngOnChanges(changes: SimpleChanges) {

  }

  ngOnInit(): void {
    this.companyId = this._authenticationService.currentUserValue.companyId;
    if(this.benefitCategory === 4)  {
      this.getByBenefit();
    }
  }

  getByBenefit = () => {
    const data =
      {
        'companyId': this.companyId,
        'benefitId': this.benefitId
      };

    this.giftTicketsService.getByBenefit(data).subscribe((e: GetGiftTicketsByBenefitResponse) => {
      this.gifTicketEvents = e.responseObject;

      const endDateLimit = new Date();
      endDateLimit.setDate(endDateLimit.getDate() + 30);
      const today = new Date();
      const todayStartOfDay = new Date();
      todayStartOfDay.setHours(0,0,0,0);


      this.gifTicketEvents.map((el) => {
        const endDate = new Date(el.endDate);
        const startDate = new Date(el.startDate);
        el.notAvailable = true;
        if (
          ( startDate < endDateLimit && startDate >= today )
          || (endDate >= todayStartOfDay && startDate <= today)
        ) {
          el.notAvailable = false;
        }
        return el;
      });


    });
  };


}
